








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BaseDropDown extends Vue {
    @Prop() public show: boolean;
    @Prop({ default: true }) public clickOutsideEnabled: boolean;

    constructor() {
        super();
    }

    public closeDropDown(event: any) {
        if (!this.clickOutsideEnabled) {
            return false;
        }

        if (!this.$el.contains(event.target)) {
            this.$emit('update:show', false);
        }
    }

    public created() {
        window.addEventListener('click', this.closeDropDown);
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }
}
